import React, {Component} from 'react';
import './Toggle.scss';

export default class Toggle extends Component {
	constructor(props) {
		super(props);

		var val = props.value;
		if(props.hasOwnProperty('checked')) {
			val = props.checked;
		}

		this.state = {
			value: !!val
		};

		this.onClick = this.onClick.bind(this);
		this.getValue = this.getValue.bind(this);
	}

	onClick() {
		if(this.props.disabled) {
			return;
		}
		var newValue = !this.state.value;

		this.setState({
			value: newValue
		});

		this.props.onChange(newValue);
	}

	componentWillReceiveProps(nextProps) {
		if(this.props.hasOwnProperty('checked')) {
			if(nextProps.checked !== this.props.checked) {
				this.setState({
					value: nextProps.checked
				});
			}
		} else {
			if(nextProps.value !== this.props.value) {
				this.setState({
					value: nextProps.value
				});
			}
		}
	}

	getValue() {
		return this.state.value;
	}

	render() {
		var classes = 'Toggle';
		if(this.props.className) {
			classes += ' '+this.props.className;
		}
		return (
			<div style={{display: 'inline'}} onClick={!this.props.disabled ? this.onClick : null}>
				<input className='Toggle-hidden-checkbox' type='checkbox' readOnly checked={this.state.value} disabled={this.props.disabled}/>
				<div className={classes}>
					<div className='toggle-handle'></div>
				</div>
			</div>
		);
	}
};


/** WEBPACK FOOTER **
 ** ./client/components/Toggle/Toggle.jsx
 **/